import React, {useEffect, useMemo, useState} from 'react';
import API from "../../../utils/API";
import {API_ENDPOINTS} from "../../../apiConfig";
import AdminDataView from "../../../components/AdminDataView";
import Forms from "../../../components/Forms";
import EditIconButton from "../../../components/Forms/EditIconButton";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import {useModal} from "../../../contexts/ModalContext";
import PartParameterModal from "../../../components/PartParameterModal";

const PartParameters = () => {
    const [rows, setRows] = useState([]);
    const [filter, setFilter] = useState('');
    const {openModal, confirm} = useModal();

    const load = async () => {
        const {data} = await API.get(API_ENDPOINTS.partParameter.list);
        setRows(data || []);
    };

    useEffect(() => {
        load();
    }, []);

    const openEdit = (parameter) => openModal(PartParameterModal, {parameter, onSaved: load}, {title: 'Upravit parametr'});
    const openNew = () => openModal(PartParameterModal, {onSaved: load}, {title: 'Nový parametr'});
    const askDelete = async (row) => {
        const ok = await confirm(`Smazat parametr ${row.label}?`);
        if (!ok) return;
        await API.delete(API_ENDPOINTS.partParameter.delete(row._id));
        await load();
    };

    const filtered = useMemo(() => {
        const q = String(filter || '').toLowerCase().trim();
        if (!q) return rows || [];
        return (rows || []).filter((row) => [row.key, row.label, row.type].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)));
    }, [rows, filter]);

    const columns = [
        {key: 'key', name: 'Key', minWidth: 180},
        {key: 'label', name: 'Název', minWidth: 240},
        {key: 'type', name: 'Datový typ', minWidth: 110},
        {key: 'active', name: 'Aktivní', minWidth: 90, renderCell: ({row}) => (row.active !== false ? 'Ano' : 'Ne')},
        {
            key: 'actions',
            name: 'Akce',
            width: 110,
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit" onClick={() => openEdit(row)}/>
                    <DeleteIconButton title="Smazat" onClick={() => askDelete(row)}/>
                </div>
            )
        }
    ].map((c) => ({...c, resizable: true}));

    return (
        <div>
            <div className="flex items-end gap-4 mb-4">
                <Forms.Button label="Přidat parametr" onClick={openNew}/>
                <div className="w-80">
                    <Forms.Text label="Filtr" value={filter} onChange={setFilter}/>
                </div>
            </div>
            <AdminDataView section="part-parameters" rows={filtered} columns={columns}/>
        </div>
    );
};

export default PartParameters;
